<template>
  <div>
    <doc-title text="Top Stories"></doc-title>

    <h1>
      Top Stories
    </h1>
    <hr>

    <list resource="posts/top"></list>
  </div>
</template>

<script>
  import DocTitle from '@/vues/helpers/doc-title.vue';
  import List from './list.vue';

  export default {
    name: 'PostsTop',
    components: { DocTitle, List }
  };
</script>
